const {
  SENDMESSAGE,
  SENDMESSAGE_SUCCESS,
  SENDMESSAGE_ERROR
} = require("../actions/send");

const sendState = (loading = false, data = {}, error = "") => ({
  loading,
  data,
  error
});

export default function(state = sendState(), { type, payload }) {
  switch (type) {
    case SENDMESSAGE:
      return sendState(true);
    case SENDMESSAGE_ERROR:
      return sendState(false, state.data, payload);
    case SENDMESSAGE_SUCCESS:
      return sendState(false, payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/send.js